import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body p-9" }
const _hoisted_3 = { class: "row mb-6" }
const _hoisted_4 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_5 = { class: "col-lg-8 fv-row" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_11 = { class: "col-lg-8 fv-row" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "row mb-6" }
const _hoisted_16 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_17 = { class: "col-lg-8 fv-row" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = { class: "col-lg-12" }
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "row mb-6" }
const _hoisted_28 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_29 = { class: "col-lg-8 fv-row" }
const _hoisted_30 = { class: "col-lg-12" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = { class: "symbol" }
const _hoisted_37 = ["title"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "form-text mt-5" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_46 = { class: "col-lg-8 fv-row" }
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row mb-6" }
const _hoisted_51 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_52 = { class: "col-lg-8 fv-row" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "fv-plugins-message-container" }
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "row mb-6" }
const _hoisted_57 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_58 = { class: "col-lg-8 fv-row" }
const _hoisted_59 = { class: "col-lg-12" }
const _hoisted_60 = { class: "fv-plugins-message-container" }
const _hoisted_61 = { class: "fv-help-block" }
const _hoisted_62 = { class: "row mb-6" }
const _hoisted_63 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_64 = { class: "col-lg-8 fv-row" }
const _hoisted_65 = { class: "fv-plugins-message-container" }
const _hoisted_66 = { class: "fv-help-block" }
const _hoisted_67 = { class: "row mb-6" }
const _hoisted_68 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_69 = { class: "col-lg-8 fv-row" }
const _hoisted_70 = { class: "fv-plugins-message-container" }
const _hoisted_71 = { class: "fv-help-block" }
const _hoisted_72 = { class: "row mb-6" }
const _hoisted_73 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_74 = { class: "col-lg-8 fv-row" }
const _hoisted_75 = { class: "row mb-6" }
const _hoisted_76 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_77 = { class: "col-lg-8 fv-row" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "fv-plugins-message-container" }
const _hoisted_80 = { class: "fv-help-block" }
const _hoisted_81 = { class: "row mb-6" }
const _hoisted_82 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_83 = { class: "col-lg-8 fv-row" }
const _hoisted_84 = { class: "fv-plugins-message-container" }
const _hoisted_85 = { class: "fv-help-block" }
const _hoisted_86 = { class: "row mb-6" }
const _hoisted_87 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_88 = { class: "col-lg-8 fv-row" }
const _hoisted_89 = { class: "fv-plugins-message-container" }
const _hoisted_90 = { class: "fv-help-block" }
const _hoisted_91 = { class: "row mb-6" }
const _hoisted_92 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "col-lg-8 fv-row" }
const _hoisted_94 = { class: "row mb-6" }
const _hoisted_95 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_96 = { class: "col-lg-8 p-3 fv-row" }
const _hoisted_97 = { class: "row mb-6" }
const _hoisted_98 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_99 = { class: "col-lg-8 p-3 fv-row" }
const _hoisted_100 = { class: "row mb-6" }
const _hoisted_101 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_102 = { class: "col-lg-8 p-3 fv-row" }
const _hoisted_103 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_104 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_105 = { class: "col-lg-8 fv-row" }
const _hoisted_106 = { class: "col-form-label fw-normal fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_CursosInscripcionesTabla = _resolveComponent("CursosInscripcionesTabla")!
  const _component_CursosDiplomasTabla = _resolveComponent("CursosDiplomasTabla")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Page, { showBack: "" }, {
    actions: _withCtx(() => [
      (!_ctx.isCreate)
        ? (_openBlock(), _createBlock(_component_el_dropdown, {
            key: 0,
            class: "mx-3"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, {
                    onClick: _ctx.eliminar,
                    disabled: (_ctx.inscripciones.length as unknown as boolean)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("page.acciones.eliminar")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, { type: "default" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("formularios.servicioDetalle.acciones.button")) + " ", 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_down)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.submit,
        loading: _ctx.crearCurso || _ctx.actualizarCurso
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.isCreate ? _ctx.$t("page.acciones.crear") : _ctx.$t("page.acciones.guardar")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, { type: "border-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.curso.tab.informacion')
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("formularios.curso.nombre.label")), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "nombre",
                          placeholder: " ",
                          modelValue: _ctx.nombre,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.nombre) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_ErrorMessage, { name: "nombre" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("formularios.curso.nexpediente.label")), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "nexpediente",
                          placeholder: " ",
                          modelValue: _ctx.nexpediente,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.nexpediente) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_ErrorMessage, { name: "nexpediente" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("formularios.curso.descripcionCorta.label")), 1),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "descripcionCorta",
                          placeholder: " ",
                          modelValue: _ctx.descripcionCorta,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.descripcionCorta) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_ErrorMessage, { name: "descripcionCorta" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("formularios.curso.descripcion.label")), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_QuillEditor, {
                          theme: "snow",
                          name: "descripcion",
                          placeholder: 
                      _ctx.$t('formularios.curso.descripcion.placeholder')
                    ,
                          contentType: "html",
                          content: _ctx.descripcion,
                          "onUpdate:content": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.descripcion) = $event)),
                          autosize: { minRows: 2 },
                          rows: 3,
                          ref: "quillEditor"
                        }, null, 8, ["placeholder", "content"])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_ErrorMessage, { name: "descripcion" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("formularios.curso.personalDocente.label")), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_QuillEditor, {
                          theme: "snow",
                          name: "personalDocente",
                          placeholder: 
                      _ctx.$t('formularios.curso.personalDocente.placeholder')
                    ,
                          contentType: "html",
                          content: _ctx.personalDocente,
                          "onUpdate:content": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.personalDocente) = $event)),
                          autosize: { minRows: 2 },
                          rows: 3,
                          ref: "quillEditor"
                        }, null, 8, ["placeholder", "content"])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(_component_ErrorMessage, { name: "personalDocente" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("formularios.curso.imagen.label")), 1),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_el_upload, {
                          class: "avatar-uploader",
                          "show-file-list": false,
                          "before-upload": _ctx.beforeAvatarUpload
                        }, {
                          trigger: _withCtx(() => [
                            _createElementVNode("label", {
                              class: "btn btn-icon btn-circle btn-active-color-info w-25px h-25px bg-body shadow position-absolute top-0 start-100 translate-middle",
                              style: {"z-index":"1"},
                              "data-kt-image-input-action": "change",
                              "data-bs-toggle": "tooltip",
                              title: _ctx.$t('formularios.curso.imagen.change')
                            }, _hoisted_39, 8, _hoisted_37)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _ctx.imagenUrl,
                              ref: "avatarImg",
                              alt: "image",
                              class: "img-thumbnail shadow w-150px"
                            }, null, 8, _hoisted_40)
                          ]),
                          _: 1
                        }, 8, ["before-upload"])
                      ]),
                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("formularios.curso.imagen.filesAllowed")), 1),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createVNode(_component_ErrorMessage, { name: "avatarUrl" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("formularios.curso.areaTematica.label")), 1),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_el_select_v2, {
                          modelValue: _ctx.areaTematica,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.areaTematica) = $event)),
                          options: _ctx.areasTematicasValues,
                          placeholder: "Selecciona el área temática",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue", "options"]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_ErrorMessage, { name: "areaTematica" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t("formularios.curso.modeloCertificado.label")), 1),
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_el_select_v2, {
                          modelValue: _ctx.modeloCertificado,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modeloCertificado) = $event)),
                          options: _ctx.modelosCertificado,
                          placeholder: "Selecciona el modelo de certificado"
                        }, null, 8, ["modelValue", "options"]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("div", _hoisted_55, [
                            _createVNode(_component_ErrorMessage, { name: "modeloCertificado" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("formularios.curso.informacionCertificado.label")), 1),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_QuillEditor, {
                          theme: "snow",
                          name: "informacionParaElCertificado",
                          placeholder: 
                      _ctx.$t('formularios.curso.informacionCertificado.placeholder')
                    ,
                          contentType: "html",
                          content: _ctx.informacionParaElCertificado,
                          "onUpdate:content": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.informacionParaElCertificado) = $event)),
                          autosize: { minRows: 2 },
                          rows: 3,
                          ref: "quillEditor"
                        }, null, 8, ["placeholder", "content"])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_ErrorMessage, { name: "informacionParaElCertificado" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t("formularios.curso.inicio.label")), 1),
                    _createElementVNode("div", _hoisted_64, [
                      _createVNode(_component_el_date_picker, {
                        format: "DD/MM/YYYY",
                        modelValue: _ctx.inicio,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inicio) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createVNode(_component_ErrorMessage, { name: "inicio" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.$t("formularios.curso.fin.label")), 1),
                    _createElementVNode("div", _hoisted_69, [
                      _createVNode(_component_el_date_picker, {
                        format: "DD/MM/YYYY",
                        modelValue: _ctx.fin,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.fin) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_component_ErrorMessage, { name: "fin" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t("formularios.curso.nhoras.label")), 1),
                    _createElementVNode("div", _hoisted_74, [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.nhoras,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.nhoras) = $event)),
                        min: 1,
                        step: 1,
                        precision: 0
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "nhoras",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_75, [
                    _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.$t("formularios.curso.horario.label")), 1),
                    _createElementVNode("div", _hoisted_77, [
                      _createElementVNode("div", _hoisted_78, [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "horario",
                          placeholder: " ",
                          modelValue: _ctx.horario,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.horario) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", _hoisted_80, [
                            _createVNode(_component_ErrorMessage, { name: "horario" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t("formularios.curso.inicioInscripciones.label")), 1),
                    _createElementVNode("div", _hoisted_83, [
                      _createVNode(_component_el_date_picker, {
                        format: "DD/MM/YYYY HH:mm",
                        type: "datetime",
                        "time-format": "HH:mm",
                        modelValue: _ctx.inicioInscripciones,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.inicioInscripciones) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _createVNode(_component_ErrorMessage, { name: "inicioInscripciones" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t("formularios.curso.finInscripciones.label")), 1),
                    _createElementVNode("div", _hoisted_88, [
                      _createVNode(_component_el_date_picker, {
                        format: "DD/MM/YYYY HH:mm",
                        type: "datetime",
                        "time-format": "HH:mm",
                        modelValue: _ctx.finInscripciones,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.finInscripciones) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                          _createVNode(_component_ErrorMessage, { name: "finInscripciones" })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t("formularios.curso.plazas.label")), 1),
                    _createElementVNode("div", _hoisted_93, [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.plazas,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.plazas) = $event)),
                        min: 1,
                        step: 1,
                        precision: 0
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "plazas",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_94, [
                    _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t("formularios.curso.publicado.label")), 1),
                    _createElementVNode("div", _hoisted_96, [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.publicado,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.publicado) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "publicado",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t("formularios.curso.presencial.label")), 1),
                    _createElementVNode("div", _hoisted_99, [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.presencial,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.presencial) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "presencial",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_100, [
                    _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t("formularios.curso.videoconferencia.label")), 1),
                    _createElementVNode("div", _hoisted_102, [
                      _createVNode(_component_el_switch, {
                        modelValue: _ctx.videoconferencia,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.videoconferencia) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "videoconferencia",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ])
                  ]),
                  (_ctx.url)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                        _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t("formularios.curso.url.label")), 1),
                        _createElementVNode("div", _hoisted_105, [
                          _createElementVNode("label", _hoisted_106, _toDisplayString(_ctx.url), 1),
                          (_ctx.isSupported)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 0,
                                icon: _ctx.Link,
                                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.copy())),
                                class: "ms-5"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.copied ? _ctx.$t("clipboard.copiado") : _ctx.$t("clipboard.copiar")), 1)
                                ]),
                                _: 1
                              }, 8, ["icon"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])), [
                [_directive_loading, _ctx.cargaDetalle]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          (!_ctx.isCreate)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 0,
                label: _ctx.$t('formularios.curso.tab.solicitudes')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _withDirectives(_createVNode(_component_CursosInscripcionesTabla, { inscripciones: _ctx.inscripciones }, null, 8, ["inscripciones"]), [
                      [_directive_loading, false]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (!_ctx.isCreate)
            ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: 1,
                label: _ctx.$t('formularios.curso.tab.diplomas'),
                name: "encuesta"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _withDirectives(_createVNode(_component_CursosDiplomasTabla, { inscripciones: _ctx.inscripciones }, null, 8, ["inscripciones"]), [
                      [_directive_loading, false]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}